var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('grid-wmx',{attrs:{"item":_vm.object,"type":"yb"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }